import { render } from "./CartTableProductOrderSubitem.vue?vue&type=template&id=3e4b8528"
import script from "./CartTableProductOrderSubitem.vue?vue&type=script&lang=js"
export * from "./CartTableProductOrderSubitem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__